import HttpService from "../http.services";

const apiManagementService = new HttpService(process.env.REACT_APP_API_URL);

class jobsServiceGlobal {
  getMassiveJobs = async (payload = {}) => {
    return await apiManagementService.post("/apiglobal/v1/getMassiveJobs", payload);
  };
}

const jobsServiceGlobalInstance = new jobsServiceGlobal();

export default jobsServiceGlobalInstance;
